import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { CCol, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormTextarea, CFormInput } from '@coreui/react'

import PhysicalExaminationAccordian from '../../components/shared/PhysicalExaminationAccordian'
import PEAddEditModel from '../../components/shared/PEAddEditModel'
import PEOptionAccordion from '../../components/shared/PEOptionAccordion'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import PEDescription from '../../components/shared/PEDescription'
import PEMedia from '../../components/shared/PEMedia'
import { Pencil } from 'lucide-react'
import HierarchyComponent from './HierarchyComponents'
import ReorderData from '../../components/shared/ReorderData'
import { SaveActivity } from './save-activity'

const GeneralExamination = ({ selectedExamination, closeEditModel, generalExaminationData, setGeneralExaminationData, parentId, setSelectedExamination, handleEditFunction, handleSubmit }) => {
  const [showAddEditPopup, setShowAddEditPopup] = useState(false)
  const [addType, setAddType] = useState(null)
  const [parentID, setParentID] = useState(null)
  const [editFormData, setEditFormData] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [hierarchy, setHierarchy] = useState(selectedExamination.hierarchy)
  const [childId, setChildId] = useState()
  const [descriptionId, setDescriptionId] = useState('')
  const [descriptionText, setDescriptionText] = useState('')
  const [showActiveFunctionality, setShowActiveFunctionality] = useState(null)
  const [educationData, setEducationData] = useState([])
  const [educationId, setEducationId] = useState(null)
  const [activeKey, setActiveKey] = useState(1)

  const [reorderModalVisible, setReorderModalVisible] = useState(false)
  const [currentReorderData, setCurrentReorderData] = useState([])
  const [currentParentItem, setCurrentParentItem] = useState(null)

  const openReorderModal = (item) => {
    setCurrentParentItem(item)
    setCurrentReorderData(item.hierarchy || [])
    setReorderModalVisible(true)
  }
  const handleReorderSave = (updatedHierarchy) => {
    const updateNestedHierarchy = (items) => {
      return items.map((i) => {
        if (i.id === currentParentItem.id) {
          return { ...i, hierarchy: updatedHierarchy }
        }
        if (i.hierarchy?.length) {
          return { ...i, hierarchy: updateNestedHierarchy(i.hierarchy) }
        }
        return i
      })
    }

    const updated = updateNestedHierarchy([...selectedExamination.hierarchy])

    const updatedSelected = {
      ...selectedExamination,
      hierarchy: updated,
    }

    setSelectedExamination(updatedSelected)

    setGeneralExaminationData((prev) => {
      return prev.map((item) => (item.id === updatedSelected.id ? updatedSelected : item))
    })
  }

  const updateGeneralExaminationData = (parentId, newItem) => {
    const updateData = (data) => {
      return data.map((item) => {
        if (item.id === parentId) {
          return {
            ...item,
            hierarchy: [...(item.hierarchy || []), ...(Array.isArray(newItem) ? newItem : [newItem])],
            isHierarchy: true,
          }
        } else if (item.hierarchy) {
          return { ...item, isHierarchy: item.hierarchy.length > 0, hierarchy: updateData(item.hierarchy) }
        }
        return item
      })
    }

    setGeneralExaminationData((prevData) => updateData(prevData))
  }

  const editGeneralExaminationData = (parentId, updatedItem) => {
    setGeneralExaminationData((prevData) => {
      const updateData = (data) => {
        return data.map((item) => {
          if (item.id === parentId) {
            return {
              ...item,
              ...updatedItem,
            }
          } else if (item.hierarchy) {
            return { ...item, hierarchy: updateData(item.hierarchy) }
          }
          return item
        })
      }

      return updateData(prevData)
    })
  }

  const deleteGeneralExaminationData = (parentId) => {
    const deleteData = (data) => {
      return data
        .filter((item) => item.id !== parentId)
        .map((item) => {
          const updatedHierarchy = item.hierarchy ? deleteData(item.hierarchy) : []

          return {
            ...item,
            hierarchy: updatedHierarchy,
            isHierarchy: updatedHierarchy.length > 0,
          }
        })
    }

    setGeneralExaminationData((prevData) => deleteData(prevData))
    setDeleteVisibleId(null)
  }

  const addData = (type, parent) => {
    setParentID(parent.id)
    setShowAddEditPopup(true)
    setAddType(type)
  }

  const editData = (data) => {
    setShowAddEditPopup(true)
    setEditFormData(data)
    setAddType(data.type)
    setParentID(data.parentId)
    setIsEdit(true)
  }

  const handleSave = (data, id = null) => {
    if (isEdit && id) {
      editGeneralExaminationData(id, { ...editFormData, ...data })
    } else {
      updateGeneralExaminationData(parentID, data)
    }

    onCloseModule()
  }

  const onCloseModule = () => {
    setShowAddEditPopup(false)
    setEditFormData(null)
    setIsEdit(false)
  }

  useEffect(() => {
    if (selectedExamination) {
      const updatedItem = generalExaminationData?.find((exam) => exam.id === selectedExamination.id)
      if (updatedItem) {
        setSelectedExamination(updatedItem)
      }
    }
  }, [generalExaminationData])

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('draggedIndex', index)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e, dropIndex) => {
    e.preventDefault()
    const draggedIndex = e.dataTransfer.getData('draggedIndex')

    if (draggedIndex === dropIndex) return

    const updatedHierarchy = [...hierarchy]
    const [movedItem] = updatedHierarchy.splice(draggedIndex, 1)
    updatedHierarchy.splice(dropIndex, 0, movedItem)
    setHierarchy(updatedHierarchy)
    setGeneralExaminationData((prev) => {
      const updatedData = [...generalExaminationData]
      updatedData[updatedData.findIndex((exam) => exam.id === selectedExamination.id)].hierarchy = updatedHierarchy
      return updatedData
    })
  }

  const handleAddTitleDescription = (item) => {
    setDescriptionText(item?.alert)
    setDescriptionId(item.id)
  }

  const handleAddEditEducationData = (item) => {
    setEducationData(item?.education || [])
    setEducationId(item.id)
  }
  const handleParentSave = (data, selectedData) => {
    handleSubmit(data)
    setSelectedExamination(selectedData)
    SaveActivity('General Examination data saved successfully.')
  }

  const renderOptions = (data) => {
    return data.map((item, index) => (
      <>
        <div className="mt-2">
          {
            <PhysicalExaminationAccordian
              title={item.name}
              key={item.id}
              setShowActiveFunctionality={setShowActiveFunctionality}
              editAccordion={() => editData(item)}
              deleteAccordion={() => setDeleteVisibleId(item.id)}
              itemData={item}
              handleAddTitleDescription={handleAddTitleDescription}
              handleAddEditEducationData={handleAddEditEducationData}
              content={
                <>
                  {item?.hierarchyType !== 'input' && (
                    <div className="d-flex justify-content-center gap-2 m-3">
                      <CButton
                        variant="outline"
                        onClick={() => addData('header', item)}
                        color="secondary"
                        className="custom-button shadow-sm"
                        style={{
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        Add/Edit Header
                      </CButton>
                      <CButton
                        variant="outline"
                        onClick={() => addData('option', item)}
                        color="success"
                        className="custom-button shadow-sm"
                        style={{
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        Add/Edit Options
                      </CButton>
                      <CButton
                        variant="outline"
                        onClick={() => openReorderModal(item)}
                        color="warning"
                        className="custom-button shadow-sm"
                        style={{
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        Rearrange
                      </CButton>
                    </div>
                  )}
                  {item?.hierarchyType === 'input' && (
                    <div className="m-3">
                      <CFormInput
                        type="text"
                        placeholder="Enter value..."
                        // value={item.inputData || ''}
                        // onChange={(e) => handleInputChange(e, item.id)}
                      />
                    </div>
                  )}
                  {renderOptions(item.hierarchy)}
                </>
              }
            />
          }
        </div>
      </>
    ))
  }

  return (
    <>
      <div>
        <div className="d-flex justify-content-between border-bottom border-secondary">
          <h5 className="p-2 m-0 text-center w-100 pe-modal-title" style={{ fontWeight: '600', cursor: 'pointer' }}>
            General Examination ({selectedExamination?.name} ) {<Pencil size={16} className="ms-1" onClick={() => handleEditFunction(selectedExamination)} />}
          </h5>
        </div>
        <div className="d-flex align-items-center justify-content-center gap-3 my-3">
          <CButton
            onClick={() => setActiveKey(1)}
            style={{
              backgroundColor: activeKey === 1 ? 'var(--ui-color-primary, #3b82f6)' : 'transparent',
              color: activeKey === 1 ? '#ffffff' : 'var(--ui-text-primary, #ffffff)',
              border: activeKey === 1 ? '1px solid var(--ui-color-primary, #3b82f6)' : '1px solid var(--ui-dashboard-border, #2d2d2d)',
              borderRadius: '8px',
              padding: '6px 28px',
              fontWeight: '500',
              fontSize: '14px',
              transition: 'all 0.2s ease',
            }}
          >
            Edit
          </CButton>
          <CButton
            onClick={() => setActiveKey(2)}
            style={{
              backgroundColor: activeKey === 2 ? 'var(--ui-color-primary, #3b82f6)' : 'transparent',
              color: activeKey === 2 ? '#ffffff' : 'var(--ui-text-primary, #ffffff)',
              border: activeKey === 2 ? '1px solid var(--ui-color-primary, #3b82f6)' : '1px solid var(--ui-dashboard-border, #2d2d2d)',
              borderRadius: '8px',
              padding: '6px 28px',
              fontWeight: '500',
              fontSize: '14px',
              transition: 'all 0.2s ease',
            }}
          >
            View
          </CButton>
        </div>
        <CTabContent>
          <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 2}>
            <HierarchyComponent viewData={selectedExamination} />
          </CTabPane>
          <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeKey === 1}>
            <motion.div className="pe-split-pane-wrapper rounded-3 position-relative" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} style={{ height: '70vh', overflow: 'auto' }}>
              <div className="d-flex flex-column h-100 ">
                <div className="d-flex flex-column h-100">
                  <div className="d-flex flex-grow-1 h-100">
                    <CCol className="d-flex flex-column align-items-center justify-content-start gap-2 border-end p-3" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                      <div className="d-flex gap-2 m-3">
                        <CButton
                          variant="outline"
                          onClick={() => addData('header', selectedExamination)}
                          color="secondary"
                          className="custom-button shadow-sm"
                          style={{
                            padding: '5px 10px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Add/Edit Header
                        </CButton>
                        <CButton
                          variant="outline"
                          onClick={() => addData('option', selectedExamination)}
                          color="success"
                          className="custom-button shadow-sm"
                          style={{
                            padding: '5px 10px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Add/Edit Options
                        </CButton>
                      </div>
                      {selectedExamination.hierarchy.map((item, index) => (
                        <div key={item.id} draggable onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)} style={{ cursor: 'grab' }} className="w-100 ">
                          <PhysicalExaminationAccordian
                            title={item.name}
                            key={index}
                            editAccordion={() => editData(item)}
                            deleteAccordion={() => setDeleteVisibleId(item.id)}
                            setChildId={setChildId}
                            itemData={item}
                            handleAddTitleDescription={handleAddTitleDescription}
                            setShowActiveFunctionality={setShowActiveFunctionality}
                            handleAddEditEducationData={handleAddEditEducationData}
                            content={
                              <>
                                {item?.hierarchyType !== 'input' && (
                                  <div className="d-flex justify-content-center gap-2 m-3">
                                    <CButton
                                      variant="outline"
                                      onClick={() => {
                                        ;(addData('header', item), setChildId(item.id))
                                      }}
                                      color="secondary"
                                      className="custom-button shadow-sm"
                                      style={{
                                        padding: '5px 10px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                      }}
                                    >
                                      Add/Edit Header
                                    </CButton>
                                    <CButton
                                      variant="outline"
                                      onClick={() => {
                                        ;(addData('option', item), setChildId(item.id))
                                      }}
                                      color="success"
                                      className="custom-button shadow-sm"
                                      style={{
                                        padding: '5px 10px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                      }}
                                    >
                                      Add/Edit Options
                                    </CButton>
                                    <CButton
                                      variant="outline"
                                      onClick={() => openReorderModal(item)}
                                      color="warning"
                                      className="custom-button shadow-sm"
                                      style={{
                                        padding: '5px 10px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                      }}
                                    >
                                      Rearrange
                                    </CButton>
                                  </div>
                                )}
                                {item?.hierarchyType === 'input' && (
                                  <div className="m-3">
                                    <CFormInput
                                      type="text"
                                      placeholder="Enter value..."
                                      // value={item.inputData || ''}
                                      // onChange={(e) => handleInputChange(e, item.id)}
                                    />
                                  </div>
                                )}
                                {renderOptions(item.hierarchy)}
                              </>
                            }
                          />
                        </div>
                      ))}
                    </CCol>

                    <CCol className="d-flex flex-column align-items-center justify-content-start p-3" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                      {showActiveFunctionality == 'description' && (
                        <PEDescription descriptionId={descriptionId} setDescriptionId={setDescriptionId} descriptionText={descriptionText} setDescriptionText={setDescriptionText} generalExaminationData={generalExaminationData} setGeneralExaminationData={setGeneralExaminationData} />
                      )}
                      {showActiveFunctionality == 'education' && <PEMedia educationId={educationId} educationData={educationData} generalExaminationData={generalExaminationData} setGeneralExaminationData={setGeneralExaminationData} parentID={parentID} />}
                    </CCol>
                  </div>
                </div>
              </div>
            </motion.div>
          </CTabPane>
        </CTabContent>
      </div>
      <hr className="my-2 border-secondary" />
      <div className="text-end p-2 d-flex justify-content-end gap-2">
        <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary px-4" onClick={() => closeEditModel()}>
          Close
        </CButton>
        <CButton className="ui-action-btn ui-action-btn--primary px-4" onClick={() => handleParentSave(generalExaminationData, selectedExamination)}>
          Save
        </CButton>
        <CButton
          className="ui-action-btn ui-action-btn--primary px-4"
          onClick={() => {
            ;(handleParentSave(generalExaminationData, selectedExamination), closeEditModel())
          }}
        >
          Save & Close
        </CButton>
      </div>

      <ReorderData visible={reorderModalVisible} onClose={() => setReorderModalVisible(false)} data={currentReorderData} onSave={handleReorderSave} />

      {/* add edit pop up */}
      <CModal backdrop="static" size="md-auto" visible={showAddEditPopup} onClose={() => onCloseModule()} className="patient-theme-modal physical-view-theme__modal">
        <CModalHeader onClose={() => onCloseModule()}>
          <CModalTitle> {isEdit ? 'Edit' : 'Add'} </CModalTitle>
        </CModalHeader>
        <CModalBody className="">
          <PEAddEditModel handleSave={handleSave} type={addType} editFormData={editFormData} isEdit={isEdit} onCloseModule={onCloseModule} parentID={selectedExamination.id} childID={childId} />
        </CModalBody>
      </CModal>

      {/* Delete Pop up */}
      <CModal backdrop="static" visible={!!deleteVisibleId} onClose={() => setDeleteVisibleId(null)} className="patient-theme-modal physical-view-theme__modal">
        <CModalHeader onClose={() => setDeleteVisibleId(null)}>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="ui-action-btn ui-action-btn--secondary"
          >
            Close
          </CButton>
          <CButton onClick={() => deleteGeneralExaminationData(deleteVisibleId)} className="ui-action-btn ui-action-btn--delete">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default GeneralExamination
